import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import _ from 'lodash'
import qs from 'qs'
import Toast from '../toast'
import { checkEmail } from '../check-email'
import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import { confirmLost, confirmFound, confirmRemovalAsImplanter } from '../animal-status-update'

Vue.use(VueGoodTablePlugin)
Vue.use(VueAxios, axios)
const url = new URL(window.location.href)
const searchTerm = url.searchParams.get('s') || ''
const filteredByOrg = (url.searchParams.get('filter') === 'true')

const tableEl = document.getElementById('v-search-table')

let path = window.location.pathname
path = path.substr(path.length - 1) === '/' ? path : path + '/'

export default Vue.component(
  'search-table',
  {
    components: {
      ModelListSelect
    },
    data () {
      return {
        searchTerm,
        displayOnlyOrganisationCA: false,
        searchedTerm: null,
        loading: false,
        hasMoreResults: false,
        errorMessage: '',
        modalType: '',
        showModal: false,
        contactModal: {
          id: null,
          avatar: '',
          name: '',
          microchipNumber: '',
          guardianName: '',
          guardianNumber: '',
          guardianAlternative: '',
          secondaryName: '',
          secondaryNumber: '',
          secondaryAlternative: '',
          link: ''
        },
        showFailureMessage: false,
        guardianAccountStatus: 'unknown',
        belongsToCurrentOrganisation: false,
        organisations: window.CANZOrganisations,
        declarations: window.CANZDeclarations,
        openActionMenuRow: null,
        token: tableEl.dataset && tableEl.dataset.token,
        companionAnimalId: null,
        companionAnimalName: '',
        isGuardian: false,
        fields: {
          FormToken: tableEl.dataset && tableEl.dataset.token,
          guardianFirstName: '',
          guardianSurname: '',
          guardianEmail: '',
          guardianMobileNumber: '',
          noEmailAvailable: false,
          noEmailReason: '',
          transferTarget: 'guardian',
          transferDeclaration: '',
          transferComments: '',
          companionAnimalID: null,
          transferOrganisationId: ''
        },
        errors: {},
        columns: [
          {
            label: '',
            field: 'avatar',
            tdClass: 'vgt-table__cell--hide-mob',
            thClass: 'vgt-table__cell--hide-mob'
          },
          {
            label: 'Name',
            field: 'name',
            tdClass: 'vgt-table__bold-cell vgt-table__name-field'
          },
          {
            label: '',
            field: 'hasImportantNote'
          },
          {
            label: 'Microchip No.',
            field: 'microchip'
          },
          {
            label: 'Species',
            field: 'species'
          },
          {
            label: 'Breed',
            field: 'breed'
          },
          {
            label: 'Date of birth',
            field: 'birthDate',
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM yyyy',
            thClass: 'vgt-left-align vgt-table__cell--hide-mob',
            tdClass: 'vgt-left-align vgt-table__cell--hide-mob'
          },
          {
            label: 'Status',
            field: 'status'
          },
          {
            label: '',
            field: 'rowContact',
            type: 'boolean' // right align
          },
          {
            label: '',
            field: 'actions',
            type: 'boolean' // right align
          }
        ],
        rows: [],
        foundMethod: "",
        comment: "",
        showComment: false
      }
    },
    created: function () {
      this.debouncedCheckEmail = _.debounce(this.checkEmail, 500)
      if (this.searchTerm !== '' || filteredByOrg) {
        this.displayOnlyOrganisationCA = filteredByOrg
        this.doSearch()
      }
    },
    methods: {
      clearEmailField () {
        if (!this.fields.noEmailAvailable) {
          this.fields.guardianEmail = ''
          delete this.errors.guardianEmail
        } else {
          this.fields.noEmailReason = ''
          delete this.errors.noEmailReason
        }
      },
      rowActionHandler (action, row) {
        if (typeof this[action] !== 'function') {
          console.error('Organisation dashboard action not found:', action)
        } else {
          this[action](row)
        }
      },
      onTransferHandler (row) {
        this.belongsToCurrentOrganisation = row.belongsToCurrentOrganisation
        this.fields.companionAnimalID = row.id
        this.fields.transferOrganisationId = ''
        this.fields.transferTarget = row.defaultTransferToMyOrg ? 'my-organisation' : 'guardian'
        this.fields.canTransferToGuardian = row.canTransferToGuardian
        this.fields.canTransferToOrganisation = row.canTransferToOrganisation
        this.fields.canTransferToOwnOrganisation = row.canTransferToOwnOrganisation
        this.fields.transferDeclaration = ''
        this.fields.transferComments = ''
        this.modalType = 'transfer'
        this.showModal = true
      },
      submitLost() {
        confirmLost.apply(this, [this.companionAnimalId, this.token])
      },
      submitFound() {
        const formData = {
          foundMethod: this.foundMethod,
          comment: this.comment
        }
        confirmFound.apply(this,[this.companionAnimalId, this.token, formData])
      },
      resetRowData() {
        this.isLost = false
        this.companionAnimalName = ""
        this.companionAnimalId = null
        this.foundMethod = ""
        this.comment = ""
      },
      confirmRemovalAsImplanter,
      refresh () {
        this.doSearch()
      },
      toggleLost (row) {
        this.isLost = row.isLost
        this.companionAnimalName = row.name
        this.companionAnimalId = row.id
        this.modalType = 'toggleLost'
        this.showModal = true
      },
      markDeceased (row) {
        this.belongsToCurrentOrganisation = row.belongsToCurrentOrganisation
        this.companionAnimalName = row.name
        this.companionAnimalId = row.id
        this.modalType = 'markAsDeceased'
        this.showModal = true
      },
      filterByOrganisation () {
        this.displayOnlyOrganisationCA = !this.displayOnlyOrganisationCA
        this.doSearch()
      },
      doSearch () {
        if (this.loading) {
          return
        }
        const loadStart = (new Date()).getTime()
        const searchParams = new URLSearchParams()
        searchParams.set('s', this.searchTerm)
        searchParams.set('filter', this.displayOnlyOrganisationCA)
        const url = new URL(window.location.href)
        url.search = searchParams.toString()
        window.history.replaceState(
          null,
          null,
          url.href
        )
        this.hasMoreResults = false
        this.errorMessage = ''
        this.rows = []
        if (this.searchTerm === '' && !this.displayOnlyOrganisationCA) {
          return
        }
        this.loading = true
        // Stop a flicker of the "no results" message while the searchTerm is set but "loading" isn't set yet
        this.searchedTerm = this.searchTerm
        this.axios({
          method: 'GET',
          url: path + 'search?s=' + encodeURIComponent(this.searchTerm) + '&filter=' + encodeURIComponent(this.displayOnlyOrganisationCA),
          maxRedirects: 0
        }).then((res) => {
          this.clearLoading(loadStart)
          if (res?.data?.status !== 'success') {
            this.errorMessage = 'An unknown error occurred, please refresh or try again later'
            this.rows = []
          } else {
            this.errorMessage = ''
            this.rows = (res?.data?.results || []).map((row) => {
              row.menuIsOpen = false
              return row
            })
            if (res?.data?.hasMoreResults) {
              this.hasMoreResults = true
            }
          }
        }).catch((err) => {
          this.clearLoading(loadStart)
          this.errorMessage = err?.response?.data?.errors?.[0]?.value || 'An unknown error occurred, please refresh or try again later'
          this.rows = []
        })
      },
      verifyStringIsNotEmpty (field) {
        return field !== null ? field : '-'
      },
      showContactModal (row) {
        this.modalType = 'contact'
        let path = window.location.pathname

        this.contactModal.avatar = row.avatar
        this.contactModal.name = row.name
        this.contactModal.link = row.link
        this.contactModal.microchipNumber = row.microchip

        path = path.substr(path.length - 1) === '/' ? path : path + '/'
        this.axios({
          method: 'GET',
          url: path + 'view-contact?caID=' + row.id,
          maxRedirects: 0
        }).then((res) => {
          this.contactModal.guardianName = res?.data?.contactInfo?.GuardianName
          this.contactModal.guardianNumber = res?.data?.contactInfo?.GuardianNumber
          this.contactModal.guardianAlternative = res?.data?.contactInfo?.GuardianAlternative
          this.contactModal.secondaryName = res?.data?.contactInfo?.SecondaryName
          this.contactModal.secondaryNumber = res?.data?.contactInfo?.SecondaryNumber
          this.contactModal.secondaryAlternative = res?.data?.contactInfo?.SecondaryAlternative
          this.showModal = true
        }).catch((err) => {
          this.errorMessage = err?.response?.data?.errors?.[0]?.value || 'An unknown error occurred, please refresh or try again later'
          this.rows = []
        })
      },
      confirmTransfer (e) {
        const url = path + 'transfer/' + this.fields.companionAnimalID
        this.loading = true
        this.errorMessage = ''
        this.axios({
          method: 'POST',
          url,
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: qs.stringify({
            ...this.fields
          }),
          maxRedirects: 0
        }).then((response) => {
          this.loading = false
          this.clearModal()
          this.doSearch()
          this.$toast.success({
            component: Toast,
            props: {
              heading: 'This companion animal has been transferred',
              body: ''
            }
          })
        }).catch((error) => {
          this.loading = false
          const errors = {}
          Object.keys(error?.response?.data?.errors || {}).forEach((k) => {
            if (typeof this.fields[k] !== 'undefined') {
              errors[k] = error.response.data.errors[k]
            } else {
              this.showFailureMessage = true
              this.errorMessage = error.response.data.errors?.[0]?.value || 'An error has occurred, please reload or try again later'
            }
          })
          this.errors = errors
        })
      },
      // Ensures the loading state is enabled for at least 500ms to show that it did something
      clearLoading (loadStart) {
        const waitBeforeClearing = 500 - ((new Date()).getTime() - loadStart)
        if (waitBeforeClearing > 0) {
          window.setTimeout(() => {
            this.loading = false
          }, waitBeforeClearing)
        } else {
          this.loading = false
        }
      },
      clearModal () {
        this.showModal = false
        this.modalType = ''
        this.contactModal.avatar = ''
        this.contactModal.id = ''
        this.contactModal.name = ''
        this.contactModal.microchipNumber = ''
        this.contactModal.guardianName = ''
        this.contactModal.guardianNumber = ''
        this.contactModal.guardianAlternative = ''
        this.contactModal.secondaryName = ''
        this.contactModal.secondaryNumber = ''
        this.contactModal.secondaryAlternative = ''
        this.contactModal.link = ''
        this.guardianAccountStatus = 'unknown'
        this.fields.guardianFirstName = ''
        this.fields.guardianSurname = ''
        this.fields.guardianEmail = ''
        this.fields.guardianMobileNumber = ''
        this.companionAnimalName = ''
        this.companionAnimalId = null
        this.errors = {}
        this.showFailureMessage = false
        this.errorMessage = ''
        this.foundMethod = ""
        this.comment = ""
      },
      checkEmail,
      onModalClose () {
        this.clearModal()
      },
      toggleActionsMenu (row) {
        if (this.openActionMenuRow) {
          this.openActionMenuRow.menuIsOpen = false
        }
        this.openActionMenuRow = this.openActionMenuRow && this.openActionMenuRow.id === row.id ? null : row
        // Close menu on click outside element:
        if (this.openActionMenuRow) {
          this.openActionMenuRow.menuIsOpen = true
          document.addEventListener('click', this.checkClickInside)
        }
      },
      checkClickInside (e) {
        var openMenu = document.getElementById('actions-menu-' + this.openActionMenuRow?.id)
        if (!!openMenu) {
          this.openActionMenuRow.menuIsOpen = false
          this.openActionMenuRow = null
          document.removeEventListener('click', this.checkClickInside)
        }
      },
      onFoundReasonChange(e) {
        if (e?.target?.value?.toLowerCase() === "other") {
          this.showComment = true
        } else {
          this.showComment = false
        }
      }
    }
  }
)
